module.exports = __webpack_public_path__ + "img/newBanner.1bc06ff0.png";